module.exports = __webpack_public_path__ + "static/media/Header.41167576.svg";